import MultiStepProvider from './MultiStepProvider';
import { MultiStepProps } from './types';

const MultiStep = <TValues extends object>({
  initialStep = 1,
  initialValues = {} as TValues,
  initialStepsDisabled = [],
  onStepChange,
  hideStepper,
  children,
}: MultiStepProps<TValues>) => {
  return (
    <MultiStepProvider<TValues>
      initialStep={initialStep}
      initialValues={initialValues}
      initialStepsDisabled={initialStepsDisabled}
      hideStepper={hideStepper}
      onStepChange={onStepChange}
    >
      {children}
    </MultiStepProvider>
  );
};

export default MultiStep;
